import en from './en'
import he from './he'
import pl from './pl'
import ru from './ru'
import ua from './ua'
import az from './az'
import hy from './hy'
import ro from './ro'
import fr from './fr'
import es from './es'
import cs from './cs'
import de from './de'
import it from './it'
import tr from './tr'
import el from './el'

export default {
	az,
	en,
	he,
	pl,
	ru,
	ua,
	hy,
	ro,
	fr,
	es,
	cs,
	de,
	it,
	tr,
	el,
}
